if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      this.setupVariantListeners(); // ← Ajouté ici
    }

    showActiveMedia() {
      const openedBy = this.openedBy;

      this.querySelectorAll(`[data-media-id]:not([data-media-id="${openedBy.getAttribute("data-media-id")}"])`)
        .forEach((element) => element.classList.remove('active'));

      const activeMedia = this.querySelector(`[data-media-id="${openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia?.querySelector('template');
      const activeMediaContent = activeMediaTemplate?.content;

      if (activeMedia) {
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ behavior: 'smooth' });

        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.clientWidth) {
          container.scrollLeft = (activeMedia.clientWidth - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      this.updateImageForVariant?.();
    }

    updateImageForVariant() {
      const variantSelector = this.querySelector('.product__select');
      const selectedVariantId = variantSelector ? variantSelector.value : null;

      if (!selectedVariantId) return;

      const variantImage = this.querySelector(`img[data-variant-id="${selectedVariantId}"]`);
      if (variantImage) {
        const activeImage = this.querySelector('.product__media-wrapper .active img');
        if (activeImage && variantImage.src !== activeImage.src) {
          activeImage.src = variantImage.src;
        }
      }
    }

    setupVariantListeners() {
      const variantSelectors = this.querySelectorAll('.product__select');
      const variantIdInput = this.querySelector('input[name="id"]');
      const variantDataElement = this.querySelector('[data-product-variants]');

      if (!variantDataElement) {
        console.warn('[MODAL] Aucune donnée de variante trouvée dans le modal.');
        return;
      }

      const variants = JSON.parse(variantDataElement.textContent);

      const updateVariantId = () => {
        const selectedOptions = Array.from(variantSelectors).map(select => select.value);
        const matchingVariant = variants.find(variant => {
          return selectedOptions.every((opt, index) => variant[`option${index + 1}`] === opt);
        });

        if (matchingVariant && variantIdInput) {
          variantIdInput.value = matchingVariant.id;
          console.log('[MODAL] Variante mise à jour :', matchingVariant);
        } else {
          console.warn('[MODAL] Aucune variante correspondante trouvée.');
        }
      };

      variantSelectors.forEach(select => {
        select.removeEventListener('change', updateVariantId); // éviter les doublons
        select.addEventListener('change', updateVariantId);
      });

      updateVariantId(); // initial
    }
  });
}
